module.exports = __webpack_public_path__ + "img/credit-card-icon.8460eb2d.svg";